// src/components/ActivityPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import BrandIdentity from './BrandIdentity';
import StaticMessaging from './StaticMessaging';

const ActivityPage = () => {
  const { pageUrl } = useParams();

  const activityComponents = {
    'brand-identity': <BrandIdentity />,
    'static-messaging': <StaticMessaging />,
    // Add more mappings as needed
  };

  return (
    <div className="p-6">
      {activityComponents[pageUrl] || (
        <p>Sorry, no activity found for <strong>{pageUrl}</strong>.</p>
      )}
    </div>
  );
};

export default ActivityPage;
